import { useContext } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  AmplitudeContext,
  AmplitudeEventConstants,
} from '@homebot/shared-util-quartermaster'
import { useAmplitudeDebounceSetters } from '../../../../hooks/tracking'

// Constants
import {
  AIRDNA_QUALITY,
  AIRDNA_FREQUENCY,
} from '../../../../constants/messages'

// Components
import Text from '../../Text'
import FormField from '../../FormField'
import PricePerNight from '../../PricePerNight'
import Slider from '../../Slider'

// Styles
import styles from './ChartControls.module.scss'

const propTypes = {
  nightsPerMonth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  pricePerNight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  paymentMax: PropTypes.number,
  rentalNightMax: PropTypes.number,
  updateSetting: PropTypes.func,
}

const SliderDescription = props => (
  <Text
    size='xs'
    variant='neutralCool'
    variantCount='700'
    align='center'
    {...props}
  />
)

const ChartControls = ({
  nightsPerMonth,
  pricePerNight,
  paymentMax,
  rentalNightMax,
  updateSetting,
}) => {
  const intl = useIntl()
  const { ampli } = useContext(AmplitudeContext)
  const [trackBasicOrFancySliderAction] = useAmplitudeDebounceSetters(() => {
    ampli?.airbnbExplored({
      airbnb_clicked: AmplitudeEventConstants.BASIC_OR_FANCY,
    })
  })
  const [trackSeldomOrOftenSliderAction] = useAmplitudeDebounceSetters(() => {
    ampli?.airbnbExplored({
      airbnb_clicked: AmplitudeEventConstants.SELDOM_OR_OFTEN,
    })
  })
  const handleUpdateSettings = e => {
    switch (e.target.name) {
      case 'nightsPerMonth':
        updateSetting(e)
        trackSeldomOrOftenSliderAction()
        break
      case 'pricePerNight':
        updateSetting(e)
        trackBasicOrFancySliderAction()
        break
      default:
        break
    }
  }
  return (
    <div className='columns columns--spaced'>
      <div className={`col slider-container ${styles.sliderContainer}`}>
        <FormField
          name='pricePerNight'
          input={Slider}
          labelText={SliderDescription}
          onChange={handleUpdateSettings}
          value={pricePerNight}
          min={25}
          max={paymentMax}
          minPhrase={intl.formatMessage(AIRDNA_QUALITY.basic)}
          maxPhrase={intl.formatMessage(AIRDNA_QUALITY.fancy)}
          step={1}
          valueFormat={PricePerNight}
        >
          <FormattedMessage
            id='AirDna.slider.pricePerNight'
            defaultMessage='How nice would you make it?'
          />
        </FormField>
      </div>
      <div className={`col slider-container ${styles.sliderContainer}`}>
        <FormField
          name='nightsPerMonth'
          input={Slider}
          labelText={SliderDescription}
          onChange={handleUpdateSettings}
          value={nightsPerMonth}
          min={1}
          max={rentalNightMax}
          minPhrase={intl.formatMessage(AIRDNA_FREQUENCY.seldom)}
          maxPhrase={intl.formatMessage(AIRDNA_FREQUENCY.often)}
          step={1}
        >
          <FormattedMessage
            id='AirDna.slider.nightsPerMonth'
            defaultMessage='Nights per month you‘d rent'
          />
        </FormField>
      </div>
    </div>
  )
}
ChartControls.propTypes = propTypes

export default ChartControls
